import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { CustomComponentTab } from './custom-component/CustomComponentTab';
import { CustomDataMappingTab } from './custom-mapping/CustomDataMappingTab';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { CUSTOM_COMPONENT, CUSTOM_DATA_MAPPING } from 'drapcode-constant';
import { checkCustomComponentPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import { CustomFunctionTab } from './custom-function/CustomFunctionTab';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class DefaultPage extends Component {
  static propTypes = {
    customComponent: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { activeTab: 'customComponent' };

  componentDidMount = () => {
    const { match, actions, location } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailCustomComponent({ projectId, version });
    actions.loadCustomDataMapping({ projectId, version });
    actions.loadCustomComponentConfigs({ projectId, version });
    actions.loadCustomFunctionConfig({ projectId, version });
    actions.getPermissionFlags({ projectId });

    if (location) {
      const { state: locationState, pathname: pathName } = location;
      const { activeTab: locationActiveTab } = locationState ? locationState : '';
      if (locationActiveTab) {
        this.toggle(locationActiveTab);
      } else {
        if (pathName.endsWith('customDataMapping')) this.toggle('customDataMapping');
        else if (pathName.endsWith('customFunction')) this.toggle('customFunction');
      }
    }
  };
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.customComponent;
    if (prevProps.customComponent.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }

  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };

  render() {
    const isAllowed = checkCustomComponentPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent containerClassName="customComponent">
          <PermissionDenied message="Custom Component" />
        </CommonPageComponent>
      );
    }

    const { match, customComponent, externalapi, home, actions } = this.props;
    const {
      projectDetail,
      customComponents,
      customDataMappings,
      customFunctions,
      loadProjectDetailCustomComponentPending,
      permissionFlags,
    } = customComponent;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { collections } = home;
    const { activeTab } = this.state;
    const { projectId, version } = match.params;
    const isReadOnly = isProjectReadOnly(projectId);
    if (loadProjectDetailCustomComponentPending || !projectDetail) {
      return (
        <CommonPageComponent parentClassName="">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
              <CustomLoader
                loading={loadProjectDetailCustomComponentPending}
                size="20px"
                color="#303453"
              />
            </div>
          </div>
        </CommonPageComponent>
      );
    }
    const { environments } = projectDetail;
    return (
      <CommonPageComponent containerClassName="customComponent">
        <AppSettingsNav activeTab={activeTab} projectDetail={projectDetail} />
        <div className="tab-content w-100">
          <div
            className={`tab-pane ${activeTab === 'customComponent' && 'active'}`}
            id="customComponent"
          >
            <CustomComponentTab
              projectId={projectId}
              version={version}
              customComponents={customComponents}
              actions={actions}
              flag={permissionsArray.includes(CUSTOM_COMPONENT)}
              isReadOnly={isReadOnly}
            />
          </div>
          <div
            className={`tab-pane ${activeTab === 'customDataMapping' && 'active'}`}
            id="customDataMapping"
          >
            <CustomDataMappingTab
              projectId={projectId}
              version={version}
              projectDetail={projectDetail}
              customDataMappings={customDataMappings}
              environments={environments}
              actions={actions}
              flag={permissionsArray.includes(CUSTOM_DATA_MAPPING)}
              isReadOnly={isReadOnly}
            />
          </div>
          <div
            className={`tab-pane ${activeTab === 'customFunction' && 'active'}`}
            id="customFunction"
          >
            <CustomFunctionTab
              collections={collections}
              projectId={projectId}
              version={version}
              customFunctions={customFunctions}
              actions={actions}
              flag={permissionsArray.includes(CUSTOM_COMPONENT)}
              isReadOnly={isReadOnly}
            />
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    customComponent: state.customComponent,
    externalapi: state.externalapi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
